<template>
    <div id="app" :class="{'has-fixed-nav':isShowBtmTab}">
        <router-view :key="key"/>
        <Btmbar v-show="isShowBtmTab"/>
    </div>
</template>
<script>
    // 微信分享
    import { wxShare } from "@/assets/scripts/wxshare";
    // 需要进行单独配置分享的页面
    const shareConfigPageList = ["/mall/demand/detail","/mall/achievement/detail","/sns/list"];
    import Btmbar from '@/containers/components/Btmbar';
    export default {
        name: 'App',
        components:{
            Btmbar
        },
        data(){
            return {
                isShowBtmTab:false
            }
        },
        computed: {
            key(){
                return this.$route.name ? this.$route.name + new Date() : this.$route + new Date();
            }
        },
        watch: {
            '$route':'getPath'
        },
        created() {
            window.onorientationchange=function(){
                if(window.orientation==90||window.orientation==-90){
                    return;
                }else{
                    window.location.reload();
                }
            }
        },
        methods: {
            getPath() {
                let path = this.$route.path;
                // 如果不是需要单独配置分享信息的页面。就使用统一的分享
                if(shareConfigPageList.indexOf(path) < 0 && path.indexOf("login") < 0){
                    wxShare({});
                }
                // let showBtmTabList = ['/index','/sns/list','/video/index','/mall/talents','/ucenter/index'];

                if(path.indexOf('news') == -1) {
                    sessionStorage.setItem("newsActive", "");
                }
                if(path.indexOf('kechuanghaolist') == -1) {
                    sessionStorage.setItem("auth_type", "");
                }
                // 判断是否要显示底部的导航
                // this.isShowBtmTab = showBtmTabList.indexOf(path) > -1;
            }
        }

    };

</script>
<style lang="scss">
    @import "@/assets/scss/mixins/_mixins.scss";
    .sidebar-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 500px;
        height: 100%;
        background-color: rgba(255, 255, 255, 1);
        transition: transform .28s;
        z-index: 1001;

        .sidebar-close {
            position: fixed;
            top: 19px;
            right: 60px;
            width: 50px;
            height: 50px;
            padding: 16px;
            cursor: pointer;

            .svg-icon {
                width: 18px;
                height: 18px;
            }
        }
        .userinfo {
            display: flex;
            padding: 60px 30px 60px 63px;

            .photo {
                width: 120px;
                height: 120px;
                border-radius: 50%;
                overflow: hidden;
                background-color: #f5f5f5;
                img{
                    height: 100%;
                }
            }
            .name {
                flex: 1;
                padding-left: 20px;
                font-size: 36px;
                font-weight: 600;
                line-height: 120px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
        }
        .user-menu {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            font-size: 24px;
            line-height: 80px;
            background-color: rgba(245, 245, 245, 1);
            border-top:1px solid rgba(229,229,229,1);
            border-bottom:1px solid rgba(229,229,229,1);
            text-align: center;

            a {
                display: inline-block;
                padding: 0 13px;
                color: rgba(51, 51, 51, 1);
                &.cur{
                    color:$red;
                }
            }
            &.not-login-menu{
                padding-left: 40px;
                justify-content: flex-start;
            }
        }
        .not-login-panel{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding:60px;
            padding-right: 0;
            border-bottom:1px solid #E5E5E5;
            .photo{
               width:120px;
               height:120px;
               border-radius:50%;
               overflow: hidden;
            }
            .handle-btn-con{
                margin-left:48px;
                a{
                    color:#333;
                    font-size:28px;
                    display: inline-block;
                    padding:10px 20px;
                    font-weight: bold;
                    border:1px solid #E5E5E5;
                    border-radius: 10px;
                    line-height: 1;
                    &:first-child{
                        border:none;
                        color:$white;
                        margin-right: 20px;
                        background-color: $red;
                    }
                }
            }
        }

        .main-nav {
            padding-top: 66px;

            li {
                margin-bottom: 40px;
                padding-left: 80px;
                // border-left: 20px solid transparent;
                font-size: 32px;
                font-weight: bold;
                line-height: 60px;


                &.cur {
                    // border-color: #C21922;
                    position: relative;

                    &:before{
                        content:"";
                        position: absolute;
                        left:0;
                        height:40px;
                        background-color: $red;
                        width:10px;
                        top:10px;
                    }
                    a {
                        color: #C21922;
                    }
                }
            }
        }
    }
    .sidebar-hide {
        .sidebar-container {
            pointer-events: none;
            transition-duration: 0.3s;
            transform: translate3d(-510px, 0, 0);
        }
    }
</style>
